'use client'

/**
 * Cart route: `/showroom/[vendor]/cart` (see `next.config.js` basePath).
 *
 * Passes `vendor` so `ShopifyCart` can detect dynamic-pricing brands (`isDynamicPricingBrand`).
 * `brand` remains the legacy path prefix for “continue shopping” links (`/gtr` → `"/gtr"`).
 */

import React from 'react'
import { useParams } from 'next/navigation'
import ShopifyCart from '@/app/components/shopify_cart'
import { useLayout } from '@/app/providers/LayoutProvider'

export default function CartPage() {
  const params = useParams()
  const vendor = (params?.vendor as string) || 'nestingale'
  const brand = vendor && vendor !== 'nestingale' ? `/${vendor}` : ''
  const { globalData } = useLayout()

  const message = JSON.stringify({
    brand: null, // cart is brand agnostic
    title: 'Shopping Cart',
  })

  return (
    <ShopifyCart
      message={message}
      brand={brand}
      vendor={vendor}
      userInfo={globalData?.userInfo}
    />
  )
}
